import { createFileRoute, Outlet } from '@tanstack/react-router';
import { usePermissions } from '@/lib/me';
import { AccessDenied } from '@/components/RouteError';
import { FinanceSubnav } from '@/components/finance/FinanceSubnav';

export const Route = createFileRoute('/_app/finance')({ component: FinanceLayout });

// The section's layout: one permission check and one tab strip for every
// finance screen. `_app` has already ensured meQuery in beforeLoad, so `can`
// answers from cache on the first render — no flash of AccessDenied.
//
// The gate admits finance.read OR finance.submit (slice 2): a submitter-only
// actor (a cleaner or handyman, spec §8.3) has no general read but still
// needs to reach /finance/submit and /finance/submissions, both nested under
// this same layout by the file-route naming. The tab strip itself stays
// finance.read-only — every tab it offers (queue, accounts, movements, …)
// 403s a submitter, so showing it would be a row of dead links.
function FinanceLayout() {
  const { can } = usePermissions();
  const canRead = can('finance.read');
  if (!canRead && !can('finance.submit')) return <AccessDenied />;
  return (
    <div className="flex flex-col gap-4">
      {canRead && <FinanceSubnav />}
      <Outlet />
    </div>
  );
}
